if (!customElements.get('bundle-product-list')) {
  class BundleProductList extends HTMLElement {
    connectedCallback() {
      if (this.isConnectedToCart) return;
      this.isConnectedToCart = true;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.isConnectedToCart = false;
    }

    handleClick = (event) => {
      const button = event.target.closest('[data-bundle-add]');
      if (!button || !this.contains(button) || this.isLoading) return;

      const items = button.hasAttribute('data-add-set')
        ? Array.from(this.querySelectorAll('[data-bundle-variant]'), (item) => ({
            id: Number(item.dataset.bundleVariant),
            quantity: 1,
          }))
        : [{ id: Number(button.dataset.variantId), quantity: 1 }];

      this.addItems(items.filter((item) => item.id), button);
    };

    async addItems(items, button) {
      if (!items.length) return;

      this.setLoading(button, true);
      this.showError();

      const body = { items };
      if (this.cart) {
        body.sections = this.cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        this.cart.setActiveElement?.(button);
      }

      try {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify(body);

        const response = await fetch(routes.cart_add_url, config).then((result) => result.json());
        if (response.status) throw new Error(response.description || response.message || 'Unable to add this item.');

        if (!this.cart) {
          window.location = routes.cart_url;
          return;
        }

        await publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'bundle-product-list',
          productVariantId: items[0].id,
          cartData: response,
        });
        this.cart.renderContents(response);
      } catch (error) {
        this.showError(error.message || 'Unable to add this item.');
      } finally {
        this.setLoading(button, false);
      }
    }

    setLoading(activeButton, state) {
      this.isLoading = state;
      this.querySelectorAll('[data-bundle-add]').forEach((button) => {
        button.disabled = state;
        button.setAttribute('aria-disabled', state);
        button.classList.toggle('loading', state && button === activeButton);
        button.querySelector('.loading__spinner')?.classList.toggle('hidden', !(state && button === activeButton));
      });
    }

    showError(message = '') {
      const error = this.querySelector('[data-bundle-error]');
      if (!error) return;
      error.textContent = message;
      error.toggleAttribute('hidden', !message);
    }
  }

  customElements.define('bundle-product-list', BundleProductList);
}
